import Phaser from "phaser";
import cover from "../assets/cover.png";
import coverButton from "../assets/cover-button.png";
import { gameVM } from "../Game.jsx";
import { canvas, resize } from "../Game.jsx";
import Loading from "./Loading";
import TCButton from "../assets/cover-button_cn2.png";
import SCButton from "../assets/cover-button_cn1.png";
import ENButton from "../assets/cover-button_eng.png";
// import instruction_4 from "../assets/info-keypoint3.png";

import clickSound from "../assets/audio/click_009.mp3";
import incorrectSound from "../assets/audio/false1.mp3";
import correctSound from "../assets/audio/true1.mp3";
import finishSound from "../assets/audio/Finish.mp3";
import emitter from "../Events/EventManager";
import { CHOOSE_TC, CHOOSE_SC, CHOOSE_EN } from "../Events/Events";
import store from "../../store/store.jsx";

export default class Scene1 extends Phaser.Scene {
  constructor() {
    super({ key: "Scene1" });
    this.Loading = new Loading(this);

    emitter.on(CHOOSE_TC, () => {
      this.TCstartButton.emit("pointerdown");
    });

    emitter.on(CHOOSE_SC, () => {
      this.SCstartButton.emit("pointerdown");
    });

    emitter.on(CHOOSE_EN, () => {
      this.ENstartButton.emit("pointerdown");
    });
  }

  preload() {
    store.dispatch({ type: "@@CHANGE_SCENE", payload: "Scene1" });
    this.load.image("cover", cover);
    this.load.image("coverButton", coverButton);
    this.load.image("TCButton", TCButton);
    this.load.image("SCButton", SCButton);
    this.load.image("ENButton", ENButton);
    this.Loading.progressBar();
    resize(canvas);
    this.preloadAudioAssets();
  }

  create() {
    this.add.image(0, 0, "cover").setOrigin(0, 0);
    this.TCstartButton = this.add.sprite(1920 * 0.42, 0.8 * 1080, "TCButton");
    this.ENstartButton = this.add.sprite(1920 * 0.58, 0.8 * 1080, "ENButton");
    this.SCstartButton = this.add.sprite(1920 * 0.5, 0.8 * 1080, "SCButton");
    this.addAudioAssets();
    this.TCstartButton.setInteractive({ cursor: "pointer" });
    this.SCstartButton.setInteractive({ cursor: "pointer" });
    this.ENstartButton.setInteractive({ cursor: "pointer" });

    this.TCstartButton.on("pointerdown", () => {
      gameVM.language = null;
      store.dispatch({
        type: "@@SELECT_LANGUAGE",
        payload: "TC",
      });
      this.sound.play("clickSound");
      this.scene.start("Scene2");
    });

    this.SCstartButton.on("pointerdown", () => {
      gameVM.language = "SC";
      store.dispatch({
        type: "@@SELECT_LANGUAGE",
        payload: "SC",
      });
      this.sound.play("clickSound");
      this.scene.start("Scene2");
    });

    this.ENstartButton.on("pointerdown", () => {
      gameVM.language = "EN";
      store.dispatch({
        type: "@@SELECT_LANGUAGE",
        payload: "EN",
      });
      this.sound.play("clickSound");
      this.scene.start("Scene2");
    });
  }

  preloadAudioAssets() {
    this.load.audio("clickSound", clickSound);
    this.load.audio("incorrectSound", incorrectSound);
    this.load.audio("correctSound", correctSound);
    this.load.audio("finishSound", finishSound);
  }

  addAudioAssets() {
    this.clickSound = this.sound.add("clickSound");
    this.incorrectSound = this.sound.add("incorrectSound");
    this.correctSound = this.sound.add("correctSound");
    this.finishSound = this.sound.add("finishSound");
  }
}
